<template>
	<div class="">
		<div class="gradient py-12 md:py-24 px-3">
			<div class="flex w-full justify-center">
				<ImageScroller :products="products" class="product-card-white" label="Featured Products" shopAll="/categories" />
			</div>
		</div>
	</div>
</template>

<script>
import Mango from '../../../helpers/mango'
import Product from '../../products/product.vue'
import ImageScroller from './image-scroller.vue'
export default {
	components: { ImageScroller, Product },
	data() {
		return {
			products: [],
			featuredBcIds: [3913, 3937, 3975, 3976, 3984, 4073, 4098, 4100, 4121, 4122, 4151, 4168],
		}
	},
	async created() {
		let products = await Mango.products({ search: { isFeatured: true }, limit: 20, sort: { sortOrder: 1 } })
		this.products = this.shuffleProducts(products)
	},

	methods: {
		shuffleProducts(products) {
			// Create a copy of the array to avoid mutating the original directly
			let array = [...products]
			for (let i = array.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1))
				;[array[i], array[j]] = [array[j], array[i]] // Swap elements
			}
			return array
		},
	},
}
</script>

<style lang="postcss" scoped>
/* This applies to child components */
.product-card-white :deep(.product-card) {
	@apply !bg-white;
}
</style>
